import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button } from "antd";
import { signIn, signOut } from "../../../authService";
import { getButtonStyle, getButtonIcon, handleHover } from "./signInButtonUtils";

const SignInButton = ({ isFromHeader = false }) => {
  const { accounts } = useMsal();
  const isAuthenticated = accounts.length > 0;

  const handleClick = async () => {
    try {
      await (isAuthenticated ? signOut("redirect") : signIn("redirect"));
    } catch (error) {
      console.error(`${isAuthenticated ? "Logout" : "Login"} failed:`, error);
    }
  };

  return (
    <Button
      onClick={handleClick}
      size={isFromHeader ? "middle" : "large"}
      icon={getButtonIcon(isFromHeader, isAuthenticated)}
      style={getButtonStyle(isFromHeader)}
      onMouseEnter={(e) => handleHover(e, isFromHeader, true)}
      onMouseLeave={(e) => handleHover(e, isFromHeader, false)}
    >
      {!isFromHeader ? (isAuthenticated ? "Sign Out" : "Sign In") : null}
    </Button>
  );
};

export const AuthenticatedTemplate = ({ children }) => {
  const { accounts } = useMsal();
  return accounts.length > 0 ? <>{children}</> : null;
};

export const UnauthenticatedTemplate = ({ children }) => {
  const { accounts } = useMsal();
  return accounts.length === 0 ? <>{children}</> : null;
};

export default SignInButton;
